import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-empty-table',
  template: `
    @if (!loading && data && data.length === 0) {
      <div class="mat-subtitle-2 empty-list padding-16">
        {{ message | translate }}
      </div>
    }
  `,
  styleUrls: ['./empty-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmptyTableComponent implements OnInit {
  @Input() loading?: boolean | null;
  @Input() data?: any[] | null;
  @Input() message: string | undefined = 'no-message';

  constructor() {}

  ngOnInit() {}
}
